import { persistentAtom } from '@nanostores/persistent';

const STORAGE_KEY = 'lastViewedAcademyContent';

const $lastViewedContent = persistentAtom<string>(STORAGE_KEY, '');

export const setLastViewedContent = (path: string) => {
  if (path) {
    $lastViewedContent.set(path);
  }
};

export const getLastViewedContent = () => {
  return $lastViewedContent.get();
};

export const clearLastViewedContent = () => {
  $lastViewedContent.set('');
};
